export class Controller {

    /** @ngInject */
    constructor($rootScope, $state) {
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    $onInit() {
        this.isSaml =
            this.$state.is('public.login-saml-with-app-id') ||
            this.$state.is('public.login-saml-with-req-link');
        this.isOldLogin =
            this.$state.is('public.old-login') ||
            this.$state.is('public.old-login-with-app-id');
    }

    switchOldRegularLogin() {
        this.$rootScope.authenticationError = false;
        this.$rootScope.captchaError = false;
        localStorage.setItem('loginAttempts', '0');

        if (this.$state.is('public.old-login-with-app-id')) {
            this.$state.go('public.login-web-saml', this.$state.params);
        } else if (this.$state.is('public.login-web-saml')) {
            this.$state.go('public.old-login-with-app-id', this.$state.params);
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/public.controller.js